import React from 'react';
import '../styles.css';

const Modal = ({ isOpen, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center md:pt-1 p-3 justify-center bg-gray-500 bg-opacity-75 overflow-x-auto">
      <div className="max-w-2xl md:max-w-3xl p-6 bg-white">
        <div className="">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
